import { FC, ReactNode } from 'react'

import { styled } from 'styled-components'

import { useUserType } from 'core/stores'

import AgentOnlyBadge from './AgentOnlyBadge'

type AgentOnlySectionProps = {
  children?: ReactNode
}

const AgentOnlySection: FC<AgentOnlySectionProps> = ({ children }) => {
  const userType = useUserType()

  if (userType !== 'agent') return null

  return (
    <Container>
      <Badge>Agent only</Badge>
      <Controls>{children}</Controls>
    </Container>
  )
}

export default AgentOnlySection

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-top: 8px;
`

const Badge = styled(AgentOnlyBadge)`
  margin-top: 2px;
`

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`
